import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Note = ({
  text
}) => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    style: {
      fontSize: 12,
      lineHeight: 1,
      color: trellisTheme.color['do-not-use-slinky']
    },
    children: text
  });
};
export default Note;